


























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import invoicesRepository from '@/modules/invoicing/services/invoicesRepository';
import notificationService from '@/services/notificationService';
import SalesNavigation from '@/modules/shared/navigation/SalesNavigation.vue';

import { DxDataGrid, DxEditing, DxColumn, DxRequiredRule, DxStateStoring, DxColumnChooser, DxColumnFixing, DxFilterRow, DxLookup } from 'devextreme-vue/data-grid';

import cCard from '@/components/default/Card.vue';
import Datagrid from '@/components/default/Datagrid.vue';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import InvoicesStats from '@/modules/invoicing/components/InvoicesStats.vue';
import { IInvoiceDto, InvoicesClient, InvoiceStatus, SendInvoicesToAccountantCommand, InvoicingClosedLogsClient, InvoicingClosedLog } from '@/data/web-api-client';
import MailPopupRappel from '@/modules/invoicing/components/MailPopupRappel.vue';
import CommunicationPopup from '@/modules/invoicing/components/CommunicationPopup.vue';
import InternalNotesLookupDialog from '@/modules/quotations/components/dialogs/InternalNotesLookupDialog.vue';
import dxDataGrid from 'devextreme/ui/data_grid';
import InvoicesBillingStats from './InvoicesBillingStats.vue';
import AuthenticationService from '@/auth/AuthenticationService';
import { SecurityConfig } from '@/installationConfig';
import InvoicingClosedLogsOverviewDialog from '@/modules/invoicing/components/InvoicingClosedLogsOverviewDialog.vue';
import moment from 'moment';
import InvoiceCannotBeDeletedDialog from './InvoiceCannotBeDeletedDialog.vue';

@Component({
  components: {
    InvoicesStats,
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxRequiredRule,
    DxStateStoring,
    DxColumnChooser,
    DxColumnFixing,
    DxFilterRow,
    DxLookup,
    cCard,
    Datagrid,
    SalesNavigation,
    MailPopupRappel,
    CommunicationPopup,
    InternalNotesLookupDialog,
    InvoicesBillingStats,
    InvoiceCannotBeDeletedDialog,
    InvoicingClosedLogsOverviewDialog: InvoicingClosedLogsOverviewDialog,
  },
})
export default class InvoicesTable extends Vue {
  @Prop({ required: false })
  public projectId: any;

  @Prop({ required: false })
  public standalone?: boolean;

  @Prop({ required: false })
  public enableSelection?: boolean;

  @Prop({ required: false })
  public expanded?: boolean;

  @Prop({ required: false })
  public metadata?: string;

  @Prop({ required: false, default: true })
  public showStats?: boolean;

  @Prop({ required: false, default: false })
  public showCloseInvoicing!: boolean;

  @Prop({ required: false, default: false })
  public disabled!: boolean;

  public showFilter: boolean = false;
  public loading: boolean = false;
  public creating: boolean = false;
  public show: boolean = false;
  public invoices: any[] = [];
  public selectedInvoices: IInvoiceDto[] = [];
  public showPopup: boolean = false;
  public invoicingClosedLogs: InvoicingClosedLog[] | null = null;

  public loadOptions: any = {};
  datasource: DataSource = new DataSource({
    store: new dxCustomStore({
      key: 'id',
      load: async (loadOptions) => {
        (loadOptions as any).stringToLower = true;
        const result = await invoicesRepository.lookup(loadOptions, this.projectId, this.metadata);
        return {
          data: result.data.data,
          totalCount: result.data.totalCount,
        };
      },
      onLoading: (loadOptions: any) => {
        this.invoiceBillingStatsLoadOptions(loadOptions);
      },
      byKey: async (val: any) => {
        return await this.client.getInvoice(val);
      },
      remove: async (val: any) => {
        try {
          await this.client.remove(val);
          notificationService.saved();
        } catch (err) {
          notificationService.showAxiosError(err);
        }
      },
    }),
    paginate: true,
  });

  private client: InvoicesClient = new InvoicesClient(undefined, this.$axios);
  private invoicingClosedLogsClient = new InvoicingClosedLogsClient(undefined, this.$axios);
  private authService = new AuthenticationService();

  public async mounted() {
    await this.loadData();
  }

  public toggleShow() {
    this.show = !this.show;
  }

  public openDetails(e: any) {
    if (e.row && !e.row.isEditing && e.column && e.column.type !== 'buttons' && e.column.type !== 'selection') {
      this.$router.push({ path: `/invoices/${e.row.data.id}`, query: { checkProjectOnHold: this.projectId ? 'false' : 'true' } });
    }
  }

  public toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  public refresh() {
    this.loadData();
  }

  public toolbarPreparing(e: any) {
    e.toolbarOptions.items.unshift(
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'fas fa-filter',
          onClick: this.toggleFilter,
        },
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'refresh',
          onClick: this.refresh,
        },
      }
    );
  }

  public refreshGrid() {
    try {
      ((this.$refs.grid as Datagrid).$refs.invoicesTable as any).instance.refresh();
    } catch {
      // do nothing
    }
  }

  public deleteRow(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        const canBeRemoved = await this.client.getInvoiceCanBeRemoved(e.data.id);

        if (!canBeRemoved) {
          (this.$refs.invoiceCannotBeDeletedDialog as InvoiceCannotBeDeletedDialog).show();

          resolve(true);
          return;
        }

        await this.client.remove(e.data.id);
        notificationService.saved();
        self.refreshGrid();
        resolve(false);
      } catch (err) {
        if (err?.response?.status === 403) {
          notificationService.showAxiosError(err);
          resolve(true);

          return;
        }

        notificationService.failedToSave();
        resolve(true);
      }
    });
  }

  public async loadData() {
    if (!this.showCloseInvoicing) {
      return;
    }

    try {
      this.loading = true;
      this.invoicingClosedLogs = await this.invoicingClosedLogsClient.get();
    } catch {
      notificationService.failedToLoad();
    } finally {
      this.loading = false;
    }
  }

  async createInvoice() {
    try {
      this.creating = true;
      const result = await this.client.create(this.projectId);
      this.$router.push({ path: `/invoices/${result}` });
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.creating = false;
    }
  }

  async sendToAccountant() {
    const invoiceIds = this.gridInstance?.getSelectedRowsData()?.map((i) => i.id) ?? [];

    if (invoiceIds.length === 0) {
      return;
    }

    const command = new SendInvoicesToAccountantCommand({
      invoiceIds: [...invoiceIds],
    });

    try {
      await this.client.sendToAccountant(command);

      notificationService.showNotification('De facturen worden in de achtergrond verstuurd naar de boekhouding', 'info');
    } catch (err) {
      notificationService.showAxiosError(err);
    }
  }

  openCloseInvoicingPopup() {
    (this.$refs.InvoicingClosedLogsOverviewDialog as InvoicingClosedLogsOverviewDialog).show();
  }

  get columns() {
    return [
      {
        dataField: 'documentNumber',
        caption: this.$t('objects.invoices.DocumentNumber'),
      },
      {
        dataField: 'projectNameNormalized',
        caption: 'Projectnaam',
        calculateCellValue(value: any) {
          if (value && value.projectName) {
            return value.projectName;
          }
          return '';
        },
      },
      {
        dataField: 'customer.displayName',
        caption: this.$t('objects.quotations.fields.Customer'),
      },
      {
        dataField: 'customerContact.displayName',
        caption: this.$t('objects.quotations.fields.CustomerContact'),
      },
      {
        dataField: 'date',
        caption: this.$t('objects.invoices.Date'),
        dataType: 'date',
        format: 'dd/MM/yyyy',
      },
      {
        dataField: 'createDate',
        caption: this.$t('objects.invoices.CreateDate'),
        dataType: 'date',
        format: 'dd/MM/yyyy',
      },
      {
        dataField: 'paymentDate',
        caption: 'Betaaldatum',
        dataType: 'date',
        format: 'dd/MM/yyyy',
      },
      {
        dataField: 'firstReminderDate',
        caption: 'Eerste rappel',
        dataType: 'date',
        format: 'dd/MM/yyyy',
      },
      {
        dataField: 'secondReminderDate',
        caption: 'Tweede rappel',
        dataType: 'date',
        format: 'dd/MM/yyyy',
      },
      {
        dataField: 'paymentNote',
        caption: 'OGM',
      },
      {
        dataField: 'status',
        caption: 'Status',
        lookup: {
          dataSource: [
            { value: InvoiceStatus.Draft, text: 'Klad' },
            { value: InvoiceStatus.Open, text: 'Open' },
            { value: InvoiceStatus.Send, text: 'Verstuurd' },
            { value: InvoiceStatus.Overdue, text: 'Te laat' },
            { value: InvoiceStatus.Paid, text: 'Betaald' },
            { value: InvoiceStatus.FirstReminder, text: 'Eerste herinnering' },
            { value: InvoiceStatus.SecondReminder, text: 'Tweede herinnering' },
          ],
          displayExpr: 'text',
          valueExpr: 'value',
        },
      },
      {
        dataField: 'total',
        caption: this.$t('objects.invoices.Total'),
        format: {
          type: 'currency',
          precision: 2,
        },
        alignment: 'left',
      },
      {
        dataField: 'totalWithTax',
        caption: 'Totaal (incl.)',
        format: {
          type: 'currency',
          precision: 2,
        },
        alignment: 'left',
        allowSearch: false,
        allowSorting: false,
      },
      {
        dataField: 'toPay',
        caption: 'Nog te betalen',
        format: {
          type: 'currency',
          precision: 2,
        },
        alignment: 'left',
      },
      {
        dataField: 'margin',
        caption: this.$t('objects.invoices.Margin'),
        dataType: 'number',
        format: {
          type: 'currency',
          precision: 2,
        },
        alignment: 'left',
      },
      {
        dataField: 'sentToAccountantDate',
        caption: 'Boekhouding',
        dataType: 'date',
        format: 'dd/MM/yyyy',
      },
      {
        dataField: 'advancedInvoice',
        caption: this.$t('objects.invoices.fields.AdvancedInvoice'),
        dataType: 'boolean',
      },
      {
        dataField: 'advancedInvoiceProcessed',
        caption: this.$t('objects.invoices.fields.AdvancedInvoiceProcessed'),
        dataType: 'boolean',
      },
      {
        type: 'buttons',
        buttons: [
          {
            hint: 'Project openen',
            icon: 'fas fa-briefcase',
            visible(e: any) {
              return !e.row.isEditing && e.row.data.projectId;
            },
            onClick: (e: any) => {
              this.$router.push({ path: `/projects/${e.row.data.projectId}` });
            },
          },
          'delete',
          {
            icon: 'far fa-comment',
            visible(e: any) {
              return e.row.data.internalNotes && e.row.data.internalNotes.replace(/(\r\n|\n|\r)/gm, '') != '';
            },
            onClick: this.lookupInternalNote,
          },
          {
            hint: 'Communicatie bekijken',
            icon: 'fas fa-users',
            visible(e: any) {
              return e.row.data.projectId;
            },
            onClick: (e: any) => {
              this.openCommunicationPopup(e.row.data.projectId);
            },
          },
        ],
      },
    ];
  }

  public setInternalNotesTooltip(e: any) {
    e.component.getVisibleRows().forEach((row: any) => {
      const cell = row.cells.find((cell: any) => cell.column.type === 'buttons');

      if (!cell) {
        return;
      }

      const buttons = Array.from((cell as any).cellElement.children);
      const button = buttons.find((button: any) => (button.className as string).indexOf('fa-comment') >= 0);

      if (!button) {
        return;
      }

      const internalNotes = (row.data as IInvoice).internalNotes;

      if (!internalNotes || internalNotes!.replace(/(\r\n|\n|\r)/gm, '') == '') {
        return;
      }

      (button as any).title = internalNotes!.replace(/(\r\n|\n|\r)/gm, '');
    });
  }

  public lookupInternalNote(e: any) {
    const invoice = e.row.data as IInvoice;
    const dialog = this.$refs.InternalNotesLookupDialog as InternalNotesLookupDialog;

    dialog.internalNotesText = invoice.internalNotes!;
    dialog.title = invoice.documentNumber == null ? invoice.projectName : invoice.documentNumber;
    dialog.show = true;
  }

  async sendRappel() {
    const grid = this.$refs.grid as Datagrid;
    if (grid) {
      const selectedRows: IInvoiceDto[] = (grid.$refs.invoicesTable as any).instance.getSelectedRowsData();
      this.selectedInvoices = selectedRows;
      try {
        const items = this.selectedInvoices
          .filter((i) => !!i.customer)
          .reduce((group, invoice) => {
            let index = invoice.customer!.id!;
            if (!group[index]) {
              group[index] = [];
            }
            group[index].push(invoice);
            return group;
          }, {} as { [key: string]: any });

        this.openMailDialog(Object.values(items));

        this.loadData();
      } catch (err) {
        notificationService.showAxiosError(err);
      }
    }
  }

  invoiceBillingStatsLoadOptions(loadOptions: any) {
    if (!loadOptions) {
      return;
    }

    this.loadOptions = { ...loadOptions };
  }

  get gridInstance() {
    return (this.$refs?.grid as any)?.$refs.invoicesTable?.instance as dxDataGrid;
  }

  get canCloseInvoicing() {
    const user = this.authService.getUser();

    if (!user) {
      return false;
    }

    const allowedRoles = [SecurityConfig.administratorGroup, SecurityConfig.invoicingRead];

    return allowedRoles.some((role) => role && this.authService.hasRole(role));
  }

  get previousInvoicingMonthClosed() {
    if (!this.invoicingClosedLogs) {
      return false;
    }

    const lastLog = this.invoicingClosedLogs.sort((a, b) => a.closedDate!.valueOf() - b.closedDate!.valueOf()).pop();

    if (!lastLog) {
      return false;
    }

    const today = moment();
    const lastLogDate = moment(lastLog.closedDate!);

    return today.isSame(lastLogDate, 'month');
  }

  @Watch('projectId')
  private onPropertyChanged(value: boolean, oldValue: boolean) {
    // Do stuff with the watcher here.
    this.loadData();
  }

  @Watch('loadOptions', { immediate: true, deep: true })
  onLoadOptionsChange() {}

  openMailDialog(invoices: any[]) {
    (this.$refs.MailPopupRappel as MailPopupRappel).open(invoices);
  }

  openCommunicationPopup(projectId: string) {
    (this.$refs.CommunicationPopup as CommunicationPopup).open(projectId);
  }
}
